import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { SimpleTextSetting } from '../types'

export type FetchSimpleTextSettingsForOptionsAction = FSA<undefined, SimpleTextSetting[], string>
type FetchSimpleTextSettingsForOptions = (searchText?: string) => MrxThunk<FetchSimpleTextSettingsForOptionsAction>
type QueryResponse = GraphQLResponse<'simpleTextSettingsForOptions', SimpleTextSetting[]>

const FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS = `
  query fetchSimpleTextSettingsForOptions ($workspaceId: Int!, $limit: Int, $searchText: String) {
    simpleTextSettingsForOptions (workspaceId: $workspaceId, limit: $limit, searchText: $searchText) {
      id
      name
    }
  }
`

const fetchSimpleTextSettingsForOptions: FetchSimpleTextSettingsForOptions = (searchText) => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS,
      variables: { workspaceId, searchText }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { simpleTextSettingsForOptions } = data
    if (!simpleTextSettingsForOptions) {
      throw new Error("Can't get Simple Text settings!")
    }

    dispatch({
      type: t.FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS,
      payload: simpleTextSettingsForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_SIMPLE_TEXT_SETTINGS_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchSimpleTextSettingsForOptions }
